import { useEffect } from 'react'

/**
 * F2.4b1 / F2.5a3 — Confirmation explicite avant intention ticket.
 * Montants € = quote serveur uniquement.
 */
export default function CaisseRecompenseConfirmDialog({
  open,
  clientLabel,
  reward,
  quote,
  message,
  totalApres = null,
  onConfirm,
  onCancel,
  busy = false,
}) {
  useEffect(() => {
    if (!open) return undefined
    const onKey = (e) => {
      if (e.key === 'Escape' && !busy) onCancel?.()
    }
    window.addEventListener('keydown', onKey)
    return () => window.removeEventListener('keydown', onKey)
  }, [open, busy, onCancel])

  if (!open) return null

  const points = Number(quote?.points)
  const valeur =
    quote?.valeurOfferte != null
      ? Number(quote.valeurOfferte)
      : Number(quote?.reductionAvantage)
  const resteOffert = Number(quote?.resteOffert || 0)
  const reduction = Number(quote?.reductionAvantage)
  const isPct = reward?.effectType === 'REDUCTION_POURCENT'
  const pct = Number(reward?.valeurPourcent)
  const pctLabel =
    Number.isFinite(pct) && pct > 0
      ? Number.isInteger(pct)
        ? String(pct)
        : String(pct)
      : null

  return (
    <div
      className="fixed inset-0 z-[90] flex items-end sm:items-center justify-center p-4 bg-black/40"
      role="dialog"
      aria-modal="true"
      aria-labelledby="caisse-reward-confirm-title"
    >
      <div className="w-full max-w-md rounded-2xl bg-white shadow-xl border border-slate-200 p-5">
        <h2 id="caisse-reward-confirm-title" className="text-lg font-semibold text-slate-900">
          Confirmer avec le client
        </h2>
        {clientLabel ? (
          <p className="text-sm text-slate-600 mt-1">Client : {clientLabel}</p>
        ) : null}
        {reward?.libelle ? (
          <p className="text-sm text-slate-600">Récompense : {reward.libelle}</p>
        ) : null}
        <p className="text-sm text-slate-800 mt-3">{message}</p>
        <ul className="mt-3 space-y-1 text-sm text-slate-700">
          {Number.isFinite(points) && points > 0 ? <li>Coût : {points} points</li> : null}
          {isPct && pctLabel ? (
            <li>Récompense : {pctLabel} %</li>
          ) : Number.isFinite(valeur) && valeur > 0 ? (
            <li>Valeur offerte : {valeur.toFixed(2)} €</li>
          ) : null}
          {Number.isFinite(reduction) && reduction > 0 ? (
            <li>Réduction : {reduction.toFixed(2)} €</li>
          ) : null}
          {Number.isFinite(Number(totalApres)) ? (
            <li>Nouveau total : {Number(totalApres).toFixed(2)} €</li>
          ) : null}
          {resteOffert > 0 ? <li>Reste offert : {resteOffert.toFixed(2)} €</li> : null}
        </ul>
        <p className="text-xs text-slate-500 mt-3">
          Aucun point ne sera débité maintenant. L’intention sera enregistrée sur le ticket.
        </p>
        <div className="mt-5 flex flex-col-reverse sm:flex-row gap-3 sm:justify-end">
          <button
            type="button"
            className="min-h-[48px] px-4 py-3 rounded-xl border border-slate-300 font-medium"
            onClick={onCancel}
            disabled={busy}
          >
            Annuler
          </button>
          <button
            type="button"
            className="min-h-[48px] px-4 py-3 rounded-xl bg-emerald-700 text-white font-semibold disabled:opacity-60"
            onClick={onConfirm}
            disabled={busy}
          >
            Confirmer
          </button>
        </div>
      </div>
    </div>
  )
}
